// noinspection SpellCheckingInspection

import styled from 'styled-components'

export const PaymentMethodsWrapper = styled.div`
  .row {
    font-size: 1.6rem;
    font-style: normal;
    font-weight: normal;
    line-height: 1.9rem;

    margin-top: 2rem;
    :first-of-type {
      margin-top: 0;
    }

    .label {
      color: #85a0ad;
      font-size: 1rem;
      line-height: 1.2rem;
      margin-bottom: 0.5rem;
      text-transform: uppercase;
    }
  }
`

export const PaymentMethodsEmpty = styled.div`
  color: #808080;
  font-style: normal;
  font-size: 1.4rem;
  font-weight: 500;
  line-height: 120%;
  text-align: center;
`
